import numeral from 'numeral';
import { action, extendObservable } from 'mobx';
import orderBy from 'lodash/orderBy';
import FetchService from '../../../core/services/FetchService';
import FormService from '../../../core/services/FormService';
import { isRequired } from '../../../core/validations';

class PlacementTestItemsListService {
  fetch = new FetchService();
  form = new FormService();

  constructor() {
    extendObservable(this, {
      items: [],
    });
    this.form.validations = {
      from: [isRequired],
      to: [isRequired],
    };
  }

  init = action(() => {
    this.items = [];
  });

  load = action(() => {
    const { from, to, ...query } = this.form.getValues();
    this.fetch
      .fetch({
        url: '/placement-test-stats',
        query: {
          ...query,
          from: from.startOf('day').toISOString(),
          to: to.endOf('day').toISOString(),
        },
      })
      .then(() => {
        if (this.fetch.data) {
          const items = orderBy(this.fetch.data, ['placementTestLevel.level', 'order'], ['asc', 'asc']);
          this.items = items.map((item) => ({
            ...item,
            errorPercentage: !item.errorPercentage ? 'N/A' : numeral(item.errorPercentage).format('0.00%'),
          }));
        } else {
          this.items = [];
        }
      });
  });
}

const placementTestItemsListService = new PlacementTestItemsListService();

export default placementTestItemsListService;
